module.exports = __webpack_public_path__ + "static/media/Default-Actor-Image.33700229.png";